/* eslint-disable no-unused-vars */
import React from 'react'

import { Bar } from 'react-chartjs-2'
import { Chart as ChartJS } from 'chart.js/auto'
import { defaults } from 'react-chartjs-2'

export default function LineChart({ chartData, option }) {
  let options = {
    locale: "fa-IR",
    responsive: true, // Instruct chart js to respond nicely.
    maintainAspectRatio: false, // Add to prevent default behaviour of full-width/height
    plugins: {
      legend: {
        position: "top",
        labels: {
          font: {
            size: 9,
            family: "iran-sans-medium",
          },
        },
      },
      title: {
        display: true,
        text: '',
        font: {
          size: 16,
          family: "iran-sans-medium",
        },
      },
      tooltip: {
        bodyFont: {
          size: 13,
          family: "iran-sans-medium",
        },
      },
    },
    scales: {
      x: {
        ticks: {
          font: {
            size: 10,
            family: "iran-sans-medium",
          },
        },
      },
      y: {
        ticks: {
          font: {
            size: 10,
            family: "iran-sans-medium",
          },
        },
      },
    },
  };
  return <Bar data={chartData} options={options} />
}
